module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("41pAN"))).then(() => parcelRequire('8rm4T'));